// Responsive common widths
// Must match widths defined in screenWidths.scss
const screenWidths = {
    minWidth: {
        xs: 375,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1600,
    },
    maxWidth: {
        xs: 767,
        sm: 991,
        md: 1199,
        lg: 1599,
    }
};
export { screenWidths };
//# sourceMappingURL=screenWidths.js.map